import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
//import history from 'utils/history';
import {
  LOAD_COMMUNICATIONS,
} from './constants';

import {
  loadCommunicationsSuccess,
  loadCommunicationsError,
} from './actions';

// utils
import api from 'utils/api';
const { endpoint } = api
import _local from 'utils/localStorageUtils';


export function* loadListSaga(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { params, childId } = action;
    let itemsList = false;
    const isParent = currentUser?.role == 'parent';

  // we get the campaigns linked to the communications
    if (!!params && (childId && !!isParent || !isParent)) {
      let postLink = endpoint?.communications?.parent?.list(currentUser?._id, childId)
      !isParent && (
        postLink = endpoint?.communications?.teacher?.list(currentUser?._id)
      )
      itemsList = yield requestWrapper(
        'POST',
        postLink,
        params,
        currentUser.token,
      );
    } else if (childId && !!isParent || !isParent) {
      let getLink = endpoint?.communications?.parent?.list(currentUser?._id, childId);
      !isParent && (
        getLink = endpoint?.communications?.teacher?.list(currentUser?._id)
      )
      itemsList = yield requestWrapper(
        'GET',
        getLink,
        '',
        currentUser.token,
      );
    }

    if (!itemsList || !!isParent && !childId) {
      yield put(loadCommunicationsSuccess(false));
    } else {
      yield put(loadCommunicationsSuccess(itemsList, itemsList?.data, params));
    }
  } catch (error) {
    yield put(loadCommunicationsError(error));
  }
}

export default function* communicationsMobileSaga() {
  yield takeLatest(LOAD_COMMUNICATIONS, loadListSaga);
}
